const Checkbox = ({ title, checked, onChange }) => {
  return (
    <div>
      <label>
        <input type="checkbox" checked={checked} onChange={onChange} />
        {title}
      </label>
    </div>
  );
};

export default Checkbox;
